
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password_reset",
      function () {
        return require("private-next-pages/password_reset/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password_reset"])
      });
    }
  